// Проверенные по Викиданным значения [рост, дата рождения, дата смерти]. Файл создаёт scripts/celebrity-seo-export.js,
// из тех же данных бот собирает блок фактов и разметку Person, поэтому посетитель и бот видят одно и то же.
import verified from "@/seo/celebrity-verified.json";

// B23: рост, вес и возраст знаменитости на её странице. Показываем только значения, прошедшие проверку:
// в базе встречаются заглушки (дата 1 января, в том числе 1990-01-01, 2019–2021 годы, пара 175 см и 70 кг)
// и выбросы (рост 1 см, вес 4 кг). Неверное значение хуже пустого места.
// Список первой волны проверен по Wikidata 17.10.2026 и совпадает с person.html.twig в frontend_for_searchbots.
// height: true, если рост совпал с Wikidata или как минимум с двумя открытыми биографическими сайтами
// (проверено 17.10.2026) в пределах 2 см.
// weight: вес по открытым биографическим сайтам на 17.10.2026 (7days.ru, 24smi, healthyceleb, bodymeasurements и др.).
// Точность приблизительная, решение фаундера 17.10.2026: люди ищут вес в поиске, неточность в пределах нескольких
// килограммов допустима. Если у страницы нет weight, берём значение из базы по общим правилам.
const WAVE1 = {
    ilia_sobolev: { height: true, weight: 60 },
    oksanasamoilova: { height: true, weight: 53 },
    brad_pitt: { height: true, weight: 78 },
    zendaya: { height: true, weight: 59 },
    sergeylazarev: { height: true, weight: 75 },
    mellstroy: { height: true, weight: 60 },
    lyubovaksyonova: { height: true, weight: 56 },
    dima_maslennikov: { height: true, weight: 72 },
    al_pacino: { height: true, weight: 70 },
    jennifer_lawrence: { height: true, weight: 60 },
    matthew_mcconaughey: { height: true, weight: 82 },
    // Личность не сопоставлена с Wikidata, фаундер решил показывать данные как есть (7days.ru: 1999-11-30, 60 кг)
    mikhaillitvin: { height: true, weight: 60 },
};

// Дата приходит как «1983-02-25T00:00:00+03:00». Берём день из самой строки: через new Date день сдвигается
// в часовом поясе браузера. Возвращает { y, m, d } или null, если значение не прошло проверку.
function parseBirth(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ""));
    if (!match) return null;
    const [y, m, d] = [+match[1], +match[2], +match[3]];
    if (m === 1 && d === 1) return null;
    if (y < 1900 || y > 2012) return null;
    return { y, m, d };
}

function ageFrom({ y, m, d }, now = new Date()) {
    let age = now.getFullYear() - y;
    const monthDiff = now.getMonth() + 1 - m;
    if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < d)) age -= 1;
    return age;
}

// Возвращает проверенные значения или null, если показывать нечего.
// Страницы первой волны: рост только подтверждённый, вес из таблицы выше, возраст по общим правилам.
// Остальные знаменитости: те же правила, рост без сверки с Wikidata.
export function celebrityFacts(slug, personalData) {
    const data = personalData || {};
    const placeholder = data.height === 175 && data.weight === 70;
    const wave = WAVE1[slug];

    const heightRangeOk = data.height >= 140 && data.height <= 220 && !placeholder;
    const height = heightRangeOk && (wave ? wave.height : true) ? data.height : null;
    const dbWeight = data.weight >= 35 && data.weight <= 200 && !placeholder ? data.weight : null;
    const weight = wave && wave.weight ? wave.weight : dbWeight;
    const v = verified[slug];
    // Рост по Викиданным заменяет значение из базы. Возраст берём по подтверждённой дате рождения: у умерших возраста нет,
    // дату 1 января считаем заглушкой, как и в боте.
    const checkedHeight = v && v[0] > 0 ? v[0] : null;
    let age;
    if (v && v[2]) {
        age = null;
    } else if (v && v[1]) {
        const checked = /^(\d{4})-(\d{2})-(\d{2})/.exec(v[1]);
        const ok = checked && !(checked[2] === "01" && checked[3] === "01");
        const value = ok ? ageFrom({ y: +checked[1], m: +checked[2], d: +checked[3] }) : null;
        age = value !== null && value >= 0 && value <= 120 ? value : null;
    } else {
        const birth = parseBirth(data.date_of_birth);
        age = birth ? ageFrom(birth) : null;
    }

    if (checkedHeight === null && height === null && weight === null && age === null) return null;
    return { height: checkedHeight !== null ? checkedHeight : height, weight, age, isWave1: !!wave };
}
